import { Container, Row, Col } from "react-bootstrap";
import Lottie from "lottie-react";
import comingSoonAnimation from "./Robot.json";

export const DocumentationPage = () => {
  return (
    <Container
      className="text-center"
      style={{ marginTop: "60px", marginBottom: "100px" }}
    >
      <Row className="w-100 align-items-center">
        
        {/* LEFT SIDE TEXT */}
        <Col
          lg={6}
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <h1 style={{ fontWeight: "bold", marginBottom: "20px" }}>
            Documentation Coming Soon
          </h1>

          <p
            style={{
              fontSize: "1.2rem",
              color: "gray",
              maxWidth: "600px",
            }}
          >
            We’re working on comprehensive documentation to help you get the most out of PARSO.
            In the meantime, you can learn using PARSO through the video tutorials below.
          </p>
        </Col>

        {/* RIGHT SIDE ANIMATION */}
        <Col
          lg={6}
          className="d-flex justify-content-center align-items-center mt-5 mt-lg-0"
        >
          <Lottie
            animationData={comingSoonAnimation}
            loop
            style={{ width: "100%", maxWidth: "400px" }}
          />
        </Col>
      </Row>

      {/* VERTICAL VIDEO DOCUMENTATION SECTION */}
      <Row className="mt-5 justify-content-center">
        <Col lg={8}>

          {/* Video 1 */}
          <h4 style={{ fontWeight: 600, marginBottom: "12px", marginTop: "20px" }}>
            1. Installation & General Overview
          </h4>

          <div className="ratio ratio-16x9 mb-5">
            <iframe
              src="https://www.youtube.com/embed/bP92Er2WA8Q"
              title="PARSO Installation"
              allowFullScreen
            />
          </div>

          {/* Video 2 */}
          <h4 style={{ fontWeight: 600, marginBottom: "12px", marginTop: "20px" }}>
            2. Optimization
          </h4>

          <div className="ratio ratio-16x9 mb-5">
            <iframe
              src="https://www.youtube.com/embed/3fX2yjP8w0o"
              title="PARSO Optimization"
              allowFullScreen
            />
          </div>

          {/* Video 3 */}
          <h4 style={{ fontWeight: 600, marginBottom: "12px", marginTop: "20px" }}>
            3. Thermal Simulation Module
          </h4>

          <div className="ratio ratio-16x9 mb-5">
            <iframe
              src="https://www.youtube.com/embed/pEGQWKj8GkM"
              title="PARSO Thermal Simulation"
              allowFullScreen
            />
          </div>

        </Col>
      </Row>
    </Container>
  );
};